import { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
//icons
import { BsSearch } from 'react-icons/bs';
//api
import { listTypes } from 'api/lists';
// slices
import { listsSelector, setTypes } from 'slices/lists';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import { SelectInputCustom } from 'components/input';

const FiltersTableLists = ({ formFilter, handleClear, setFormFilter, t, page, setPage }) => {
  const { types } = useSelector(listsSelector);
  const dispatch = useDispatch();

  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };


  useEffect(() => {
    const getListTypes = async () => {
      const { data, status } = await listTypes();
      if (status === 200) {
        let typesTemp = data?.map((item) => ({ id: item[0], value: item[1] }));
        typesTemp.unshift({ id: '', value: t('faqs.none') });
        dispatch(setTypes(typesTemp));
      }
    };

    if (types?.length === 0) getListTypes();
  }, []);

  return (
    <SearchTable multipleInput={true} handleClear={handleClear}>
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <SelectInputCustom
          choices={types}
          label={t('tipo')}
          onCheckedItem={(e) => handleSearch(e, 'tipo')}
          value={formFilter.tipo}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          placeholder={t('searchByTitle')}
          value={formFilter.nombre}
          label={t('name')}
          onChange={(e) => handleSearch(e, 'nombre')}
          icon={<BsSearch color="#161A25" className="icon-search" />}
        />
      </Form>
    </SearchTable>
  );
};

FiltersTableLists.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func,
};

export default FiltersTableLists;
